import { render, staticRenderFns } from "./bindingPhone.vue?vue&type=template&id=62841f9c&scoped=true"
import script from "./bindingPhone.vue?vue&type=script&lang=js"
export * from "./bindingPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62841f9c",
  null
  
)

export default component.exports